module.exports = __webpack_public_path__ + "static/media/434144684_904951411369785_1179975032717874696_n.9e9a5f32.jpg";